import http from "../config/http-common";
import axios from "axios";
import authHeader from "./auth-header";

import server from "../config/server.config";

const API_URL = server.host + ":" + server.port + "/api/user/";

class ShoppingListDataServiceClass {
  getAll(params) {
    const response = http.get("/api/user/shoppinglists", {
      headers: authHeader(),
      params: params,
    });
    // console.log("response ", response);
    return response;
  }

  get(id) {
    return http.get(`/api/user/shoppinglists/${id}`, { headers: authHeader() });
  }

  getIngredient(id, itemId) {
    return http.get(`/api/user/shoppinglists/${id}/items/${itemId}`, {
      headers: authHeader(),
    });
  }

  create(data) {
    // console.log("data ", data);
    return http.post("/api/user/shoppinglists/add", data, {
      headers: authHeader(),
    });
  }

  update(id, data) {
    console.log("data ", data);
    return http.put(`/api/user/shoppinglists/${id}`, data, {
      headers: authHeader(),
    });
  }

  delete(id) {
    return http.delete(`/api/user/shoppinglists/${id}`, {
      headers: authHeader(),
    });
  }

  deleteAll() {
    return http.delete(`/api/user/shoppinglists`, { headers: authHeader() });
  }

  findByName(name) {
    return http.get(`/api/user/shoppinglists?name=${name}`, {
      headers: authHeader(),
    });
  }

  getShoppingList(user) {
    let userID;
    if (user.memberOf === user._id) {
      // no family/club or family/club administrator
      userID = user.id;
    } else {
      // the user is a family/club member
      userID = user.memberOf;
    }
    console.log("-----------------------------> ", userID)
    return axios.get(`${API_URL}shoppinglists/${userID}`, {
      timeout: 1000,
      headers: authHeader(),
    });
  }

  postShoppingList(user, items) {
    let userID;
    if (user.memberOf === user._id) {
      // no family/club or family/club administrator
      userID = user.id;
    } else {
      // the user is a family/club member
      userID = user.memberOf;
    }
    console.log("-----------------------------> ", userID);
    const data = {
      userid: userID,
      // shoppinglist: items,
      items: items,
    };
    // console.log(data);
    return axios.post(API_URL + "shoppinglists", data, {
      // `method` is the request method to be used when making the request
      method: "post", // default "get"
      headers: authHeader(),
      timeout: 1000, // default is `0` (no timeout)
    });
  }
}
const ShoppingListDataService = new ShoppingListDataServiceClass();
export default ShoppingListDataService;
